/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';
import { t } from 'utils/translates';
import DeadlineTimer from '../../../../Common/DeadlineTimer';

// eslint-disable-next-line react/prefer-stateless-function
class Header extends Component {
  render() {
    const timerDeadline = () => {
      if ([1, 3].includes(this.props.exec.status)) {
        return (
          <li
            className="text-muted"
            data-toggle="tooltip"
            data-placement="right"
            data-original-title={t('Оставшееся время на выполнение задания')}
          >
            <i className="fa fa-clock-o" />{' '}
            <DeadlineTimer
              key={`deadlinePerformTime-${this.props.exec.id}`}
              secondsLeft={this.props.exec.deadlinePerformTimer}
            />
          </li>
        );
      } else if ([2].includes(this.props.exec.status)) {
        return (
          <li
            className="text-muted"
            data-toggle="tooltip"
            data-placement="right"
            data-original-title={t('Оставшееся время на проверку задания')}
          >
            <i className="fa fa-clock-o" />{' '}
            <DeadlineTimer
              key={`deadlineCheckedTime-${this.props.exec.id}`}
              secondsLeft={this.props.exec.deadlineCheckedTimer}
            />
          </li>
        );
      }
      return null;
    };
    return (
      <div className="panel-heading">
        <div className="task-table">
          <div className="task-cell">
            <h2 className="h3 task-title" title={this.props.exec.task.title}>
              {this.props.typeLayout === 'view' ? (
                this.props.exec.task.title
              ) : (
                <NavLink
                  to={`/my-tasks/view/${this.props.exec.task.id}`}
                  title={this.props.exec.task.title}
                >
                  {this.props.exec.task.title}
                </NavLink>
              )}
            </h2>
          </div>
          <div className="task-cell task-price">
            <div className="task-price-val">
              <span className="h3">{this.props.exec.task.costExecution}</span> ₽
            </div>
          </div>
        </div>
        <ul className="list-inline task-info">
          <li className="text-muted">
            {formatter.dateFormat3(this.props.exec.task.createdAt)}
          </li>
          <li className="text-muted">ID{this.props.exec.task.id}</li>
          <li title={`http://${this.props.exec.task.taskDomain}`}>
            <a
              className="text-success text-underline"
              target="_blank"
              rel="noopener noreferrer"
              href={`http://${this.props.exec.task.taskDomain}`}
            >
              {this.props.exec.task.taskDomain}
            </a>
          </li>
          <li>
            <NavLink
              to={`/users/profile/${this.props.exec.task.ownerId}`}
              className="text-muted"
            >
              <div className="media media_inline-table">
                <div className="media-left">
                  <img
                    alt={''}
                    className="media-object avatar avatar-xxs"
                    src={this.props.exec.task.ownerAvatarPath}
                  />
                </div>
                <div className="media-body media-middle">
                  <div
                    className="text-overflow text-overflow_sm"
                    title={this.props.exec.task.ownerUserName}
                  >
                    {this.props.exec.task.ownerUserName}
                  </div>
                </div>
              </div>
            </NavLink>
          </li>
          {timerDeadline()}
        </ul>
      </div>
    );
  }
}

Header.defaultProps = {
  typeLayout: 'list'
};

Header.propTypes = {
  typeLayout: PropTypes.oneOf(['list', 'view']),
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    deadlinePerformTimer: PropTypes.number.isRequired,
    deadlineCheckedTimer: PropTypes.number,
    task: PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      taskDomain: PropTypes.string.isRequired,
      costExecution: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      ownerId: PropTypes.number.isRequired,
      ownerAvatarPath: PropTypes.string.isRequired,
      ownerUserName: PropTypes.string.isRequired,
      taskCommentsStat: PropTypes.shape({
        dislikes: PropTypes.number.isRequired,
        likes: PropTypes.number.isRequired,
        neutral: PropTypes.number.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecTaskOwnerItem/Header.js